import {
  CalendarDate,
  CalendarDateTime,
  ZonedDateTime,
} from '@internationalized/date';

export const dateToCalendarDate = (date: Date): CalendarDate =>
  new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate());

export const dateToCalendarDateTime = (date: Date): CalendarDateTime =>
  new CalendarDateTime(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds(),
  );

export const seconds = (seconds: number) => seconds * 1000;
export const minutes = (minutes: number) => minutes * seconds(60);
export const hours = (hours: number) => hours * minutes(60);
export const days = (days: number) => days * hours(24);
export const weeks = (weeks: number) => weeks * days(7);
export const years = (years: number) => years * days(365);

export const isDateWithinHours = (
  date: CalendarDateTime | ZonedDateTime | null | undefined,
  thresholdHours: number,
): boolean => {
  if (!date) return false;
  const nativeDate = new Date(
    date.year,
    date.month - 1,
    date.day,
    date.hour,
    date.minute,
    date.second,
  );
  return Date.now() - nativeDate.getTime() < hours(thresholdHours);
};

export const compareDates = (
  a: CalendarDate | ZonedDateTime | null | undefined,
  b: CalendarDate | ZonedDateTime | null | undefined,
): number => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;

  const dateA = new Date(a.year, a.month - 1, a.day);
  const dateB = new Date(b.year, b.month - 1, b.day);

  return dateA.getTime() - dateB.getTime();
};
